import { render, staticRenderFns } from "./addProductBatch.vue?vue&type=template&id=733af528&scoped=true"
import script from "./addProductBatch.vue?vue&type=script&lang=js"
export * from "./addProductBatch.vue?vue&type=script&lang=js"
import style0 from "./addProductBatch.vue?vue&type=style&index=0&id=733af528&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733af528",
  null
  
)

export default component.exports